import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

// Get all templates
const getMe = async () => {
  try {
    return await axios.get(`${API_URL}/me`);
  } catch (error) {
    throw error;
  }
};

const userApi = {};

userApi.getMe = getMe;

export default userApi;
